import { ReactNode } from "react";

const RegisterPage: React.FC<{ children?: ReactNode }> = (props) => (
  <div>{props.children}</div>
);

export default RegisterPage;
